import React, { forwardRef, useImperativeHandle, useRef } from 'react';

import MuiTextField from '@mui/material/TextField';
import { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField/TextField';

export type TextFieldProps = MuiTextFieldProps;

export default forwardRef(function TextField(
    props: TextFieldProps,
    forwardedRef
) {
    const { children, ...rest } = props;
    const inputRef = useRef<HTMLInputElement>();

    useImperativeHandle(forwardedRef, () => inputRef.current, []);

    return (
        <MuiTextField
            variant="standard"
            {...rest}
            slotProps={{
                ...rest.slotProps,
                htmlInput: {
                    //https://foreflight.slack.com/archives/C07JJ56EW4R/p1733166317272369?thread_ts=1733163225.696309&cid=C07JJ56EW4R
                    // When a browser autofill it changes the css, and gives very little flexibility to overwrite it. The
                    // solution is to just turn it off completely.
                    autoComplete: 'off',
                    ...rest.slotProps?.htmlInput,
                },
            }}
            inputRef={inputRef}
        >
            {children}
        </MuiTextField>
    );
});
